export const VENDOR_LIST = "P2P_VENDOR_LIST";
export const GAME_LIST = "P2P_GAME_LIST";
export const P2P_GAME_ACCESS = "P2P_GAME_ACCESS";
